import _ from "lodash";
import { checkAndUpdateToken } from "./auth";

import { BACKEND_URL_PREFIX } from "../utils/const";
import {
  UNREAD_MESSAGE_FETCH_COMPLETED,
  CHATS_FETCH_COMPLETED,
  CHAT_FETCH_STARTED,
  CHAT_FETCH_COMPLETED,
  LK_FETCH_COMPLETED,
  LK_PHOTO_FETCH_COMPLETED,
  RATE_FETCH_COMPLETED,
  USERS_FETCH_COMPLETED,
  CHAT_MESSAGES_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
  CHAT_PHOTOS_FETCHED,
  UPDATE_PASSWORD_ERROR,
  AUTH_COMPLETED,
  SELF_PHOTO,
  PORTFOLIO_PRACTICE_FETCH_COMPLETED,
  LK_SCHEDULE_TODAY_FETCH_COMPLETED
} from "./types";
import { buildDefaultHeaders, arrayBufferToBase64 } from "./helper";
import { createNotification } from "../components/notifications/notifications";

export const lk = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const mid = getState().auth.mid;
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/users/${mid}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: LK_FETCH_COMPLETED,
        data: {
          ...data.userDetails[0],
          teacherDetails: data.teacherDetails[0],
          teacherDetails_: data.teacherDetails[1],
        },
      });
    }
  }
};

export const unreadMessages = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/message`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: UNREAD_MESSAGE_FETCH_COMPLETED,
        unreadMessages: data.unread,
      });
    }
  }
};

export const selfPhoto = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const responsePhoto = await fetch(
      `${BACKEND_URL_PREFIX}/user/${getState().auth.mid}/photo`,
      buildDefaultHeaders(getState)
    );

    if (responsePhoto.ok) {
      const buffer = await responsePhoto.arrayBuffer();
      // eslint-disable-next-line
      const photo = arrayBufferToBase64(buffer);
      dispatch({ type: SELF_PHOTO, photo });
    }
  }
};

export const photo = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const mid = getState().auth.mid;
    const responsePhoto = await fetch(
      `${BACKEND_URL_PREFIX}/users/${mid}/photo`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, responsePhoto });

    if (responsePhoto.ok) {
      const buffer = await responsePhoto.arrayBuffer();
      // eslint-disable-next-line
      const photo = arrayBufferToBase64(buffer);
      dispatch({ type: LK_PHOTO_FETCH_COMPLETED, photo });
    }
  }
};

export const chatPhoto = (userId) =>
  // eslint-disable-next-line
  async (dispatch, getState) => {
    const responsePhoto = await fetch(
      `${BACKEND_URL_PREFIX}/users/${userId}/photo`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, responsePhoto });

    if (responsePhoto.ok) {
      const buffer = await responsePhoto.arrayBuffer();
      const convertPhoto = arrayBufferToBase64(buffer);
      dispatch({ type: CHAT_PHOTOS_FETCHED, userId, photo: convertPhoto });
    }
  };

export const chats = () => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/message/chat`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    // eslint-disable-next-line
    data.chat.forEach(async (elem) => await dispatch(chatPhoto(elem.photoid)));
    dispatch({ type: CHATS_FETCH_COMPLETED, chats: data.chat });
  }
};

export const loadChatInfo = (chatId, toId) => async (dispatch, getState) => {
  dispatch({ type: CHAT_FETCH_STARTED });
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/message/chat/${chatId}`,
    buildDefaultHeaders(getState)
  );
  const responsePhoto = await fetch(
    `${BACKEND_URL_PREFIX}/users/${toId}/photo`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const buffer = await responsePhoto.arrayBuffer();
    const convertPhoto = arrayBufferToBase64(buffer);
    const data = await response.json();
    const chat = { ...data.chatinfo.chatinfo[0] };
    dispatch({
      type: CHAT_FETCH_COMPLETED,
      chatInfo: { chat: { ...chat, photo: convertPhoto } },
    });
    dispatch(chatPhoto(chat.photoid));
  }
};

export const loadMessages = (chatId) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/message/chat/${chatId}/message`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: CHAT_MESSAGES_FETCH_COMPLETED, messages: data });
  }
};

export const getUsers = (val = '') => async (dispatch, getState) => {
  const params = val ? `?composition=${val}` : null // сделать выбор 
  //   постоянный состав:
  // http://127.0.0.1:5000/lms/api/v1.0/studium/message/users?composition=constant
  // переменный:
  // http://127.0.0.1:5000/lms/api/v1.0/studium/message/users?composition=temporary
  // и те и другие:
  // http://127.0.0.1:5000/lms/api/v1.0/studium/message/users
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/message/users${params ? params : ''}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    const dataForce = data.map((elem) => ({
      ...elem,
      fullName: `${elem.lastname} ${elem.firstname} ${elem.patronymic}`,
    }));
    dispatch({ type: USERS_FETCH_COMPLETED, data: dataForce });
  }
};

export const createChat = (val, mid) => async (dispatch, getState) => {
  const response = await fetch(`${BACKEND_URL_PREFIX}/message/chat`, {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
    },
    body: JSON.stringify({
      tomid: mid,
      title: val.title,
      message: val.message,
    }),
  });

  dispatch({ type: NETWORK_REQUEST_SENT, response });
  const data = await response.json();
  let isTrue = false;

  if (response.ok) {
    createNotification('success', 'Сообщение успешно отправлено!');
    dispatch(chats());
    isTrue = true;
  } else {
    createNotification('error', data.message)
  }
  return isTrue;
};

export const sendMessage = (message, chatId, parentId, messageId) => async (
  dispatch,
  getState
) => {

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/message/chat/${chatId}/message`,
    {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
      },
      body: JSON.stringify({
        parent: messageId || 0,
        message,
      }),
    }
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    dispatch(loadMessages(chatId));
    createNotification('success', 'Сообщение успешно отправлено!');
  }
};

export const deleteMessage = (chatId, messageId) => async (
  dispatch,
  getState
) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/message/chat/${chatId}/message/${messageId}`,
    {
      method: "DELETE",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
      },
    }
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    dispatch(loadMessages(chatId));
    createNotification('success', 'Сообщение успешно удалено!');
  }
};

export const deleteChat = (chatId) => async (dispatch, getState) => {
  const response = await fetch(`${BACKEND_URL_PREFIX}/message/chat/${chatId}`, {
    method: "DELETE",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
    },
  });

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    dispatch(chats());
    createNotification('success', 'Диалог успешно удален!');
  }
};

export const rate = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const mid = getState().auth.mid;
    const responsePhoto = await fetch(
      `${BACKEND_URL_PREFIX}/users/${mid}/rate`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, responsePhoto });

    if (responsePhoto.ok) {
      const data = await responsePhoto.json();

      dispatch({
        type: RATE_FETCH_COMPLETED,
        rateList: [
          {
            name: "Рейтинг по группе",
            list: _.orderBy(
              data[0].gid,
              ["num", "xp_f_get_mid_fio"],
              ["asc", "asc"]
            ),
          },
          {
            name: "Рейтинг по курсу",
            list: _.orderBy(
              data[1].year,
              ["num", "xp_f_get_mid_fio"],
              ["asc", "asc"]
            ),
          },
          {
            name: "Рейтинг по факультету",
            list: _.orderBy(
              data[2].idfaculty,
              ["num", "xp_f_get_mid_fio"],
              ["asc", "asc"]
            ),
          },
        ],
      });
    } else {
      dispatch({
        type: RATE_FETCH_COMPLETED,
        rateList: [],
      });
    }
  }
};

export const setPassword = (values) => async (dispatch, getState) => {
  const response = await fetch(`${BACKEND_URL_PREFIX}/users/password`, {
    method: "POST",
    body: JSON.stringify(values),
    ...buildDefaultHeaders(getState),
  });

  if (response.ok) {
    const data = { ...getState.auth };
    dispatch({
      type: AUTH_COMPLETED,
      user: {
        ...data,
        need_change_password: false,
      },
    });
    dispatch(setPasswordError("success"));
  } else {
    const data = await response.json();
    dispatch(setPasswordError(data));
  }
};

export const setPasswordError = (passwordError) => ({
  type: UPDATE_PASSWORD_ERROR,
  passwordError,
});

// РАСПИСАНИЕ ЛИЧНОГО КАБИНЕТА (занятия и мероприятия на сегодня)
export const getScheduleToday = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const type = getState().auth.isTeacher ? "teacher" : "student";
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/cabinet/schedule/today?type=${type}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: LK_SCHEDULE_TODAY_FETCH_COMPLETED, scheduleToday: data });
    }
  }
};

// ПОРТФОЛИО ПДФ ПРАКТИКИ
export const getPractice = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const mid = getState().auth.mid;
    const url = `${BACKEND_URL_PREFIX}/practice/grades`;
    const response = await fetch(url, buildDefaultHeaders(getState));

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const practice = await response.json();
      dispatch({ type: PORTFOLIO_PRACTICE_FETCH_COMPLETED, practice: practice });
    }
  }
};
